import React, { useEffect, useState } from "react";
import {
  GetMsisdn,
  login,
  requestStatus,
} from "../services/client-login-service";
import { getMsisdn } from "../utils/global";
import { TRACKERIDS } from "../utils/tracker";
import { useNavigate, useLocation, Link } from "react-router-dom";
import OTPInput from "react-otp-input";
import ActivityIndicator from "../components/ActivityIndicators/ActivityIndicator";
import styles from "./Login.module.css";
import {
  setVInfo,
  getTrackerId,
  setTrackerId,
  setMsisdn,
} from "../utils/global";
import {
  clientLogin,
  Register,
  fetchOtp,
  otpVerification,
} from "../services/client-login-service";
import { userSessionID, userSession } from "../services/client-login-service";
import TiktokPixel from "tiktok-pixel";
import axios from "axios";
import { param } from "jquery";
import { toast } from "react-toastify";

const Login = () => {
  //
  const [IsLoading, setIsLoading] = useState(false);
  const [otp, setotp] = useState("");
  const [timer, setTimer] = useState(5 * 60);
  const [isHideOTP, setisHideOTP] = useState(false);
  const [SendOtp, setSendOtp] = useState(false);
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [startTimer, setStartTimer] = useState(false);
  const [isClicked, setisClicked] = useState(false);
  let countOfSuccess = 0;
  //

  //
  var checkcharged = 0;
  //
  var count = 0;
  var alreadyregister = 0;
  const navigate = useNavigate();
  const location = useLocation();

  // var vInfo = '';
  var partnerName = "";
  // var trackerId = '';
  // var hecase=false;
  var Msisdn;
  var msisdnFetched = false;
  var otpSent = 0;

  var queryParams = new URLSearchParams(location.search);
  var params = { undefined };

  //
  useEffect(() => {
    const inputValue = document.getElementById("LoginMsisdn")?.value;
    if (inputValue && inputValue !== "") {
      setStartTimer(true);
    }
  }, []);

  //
  useEffect(() => {
    let interval;

    if (startTimer && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    }

    if (timer === 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [startTimer, timer]);

  //useeffect to check the OTP timer and config it again
  useEffect(() => {
    if (timer === 0) {
      setTimer(200);
      //
      setTimeout(() => {
        if (SendOtp) {
          setSendOtp(false);
        } else {
          setSendOtp(true);
        }
      }, 1000);

      // window.location.reload();
    }
  }, [timer]);

  //
  //

  useEffect(() => {
    // Store query parameters in localStorage

    queryParams.forEach((value, key) => {
      localStorage.setItem(key, value);
    });

    if (
      queryParams.get("msisdn") != null &&
      queryParams.get("msisdn") != "not_found"
    ) {
      var encryptedMsisdnArray = queryParams.get("msisdn").split(/[.%]/);

      var encryptedMsisdn = encryptedMsisdnArray[0];
      var decryptedMsisdn = atob(encryptedMsisdn) / 99;

      decryptedMsisdn = "0" + decryptedMsisdn.toString().substring(2);
      console.log("Decrypted MSISDN: here by asad 1 " + decryptedMsisdn);
      document.getElementById("LoginMsisdn").value = decryptedMsisdn;

      if (queryParams.get("ip") !== null || queryParams.get("port") !== null) {
        // https://gamenow.ntgarage.com/index.php?msisdn=OTEzOTc2NTYyMTUwNjM=&vinfo=null&ip=null&port=62089
        var ipAddress = queryParams.get("ip").split(/[.%]/);
        var port = queryParams.get("port").split(/[.%]/);
        localStorage.setItem("ip", ipAddress);
        localStorage.setItem("port", port);
      }
      // click the button after 3 seconds
      document.getElementById("LoginButton").click();
    }
    // const sessionId = localStorage.getItem("UserSessionId");
    // if (sessionId == null) {
    //   userSessionID().then(
    //     (userSessionID) => {
    //       localStorage.setItem("UserSessionId", userSessionID + 1);
    //       const session = {
    //         userSessionId: localStorage.getItem("UserSessionId"),
    //         sessionType: "LoginPage",
    //       };
    //       userSession(session).then(
    //         (userSessionResponse) => {},
    //         (userSessionError) => {
    //           console.log(userSessionError);
    //         }
    //       );
    //     },
    //     (userSessionIdError) => {
    //       console.log(userSessionIdError);
    //     }
    //   );
    // } else {
    //   const session = {
    //     userSessionId: localStorage.getItem("UserSessionId"),
    //     sessionType: "LoginPage",
    //   };
    //   userSession(session).then(
    //     (userSessionResponse) => {},
    //     (userSessionError) => {
    //       console.log(userSessionError);
    //     }
    //   );
    // }

    if (
      queryParams.get("unsub") === "true" &&
      queryParams.get("msisdn") != ""
    ) {
      navigate("/unsub-portal");
      return;
    }
    if (queryParams.get("unsub") === "true") {
      navigate("/usub");
      return;
    }
    if (queryParams.get("logout") === "1") {
      navigate("/logout");
      return;
    }

    try {
      console.log("Vinfo from ayaz");
      console.log(
        "Vinfo came from Ayaz ----->>>>>    " + queryParams.get("vinfo")
      );

      params = queryParams.get("vinfo").split(/[.:]/);
      //

      if (
        params[0] == "null" ||
        params[0] == "undefined" ||
        params[0] == null
      ) {
        let mobikok = params[1];

        if (mobikok == "mobikok") {
          //
          setTrackerId(mobikok);
          console.log("Tracker ID here mobikok: " + mobikok);
        }

        if (mobikok == "propellerads") {
          setTrackerId(mobikok);
          console.log("Tracker ID here propellerads: " + mobikok);
        }

        if (mobikok == "2m18i") {
          setTrackerId(mobikok);
          console.log("Tracker ID here 2m18i: " + mobikok);
        }
        if (mobikok == "goldengoose") {
          setTrackerId(mobikok);
          console.log("Tracker ID here goldengoose: " + mobikok);
        }
        if (mobikok == "Innomovil") {
          setTrackerId(mobikok);
          console.log("Tracker ID here Innomovil: " + mobikok);
        }

        console.log(param);

        localStorage.setItem("TRACKER_ID", params[0]);
      } else {
        setTrackerId(params[0]);
        console.log("if (params[0] != null " + params[0]);
        localStorage.setItem("TRACKER_ID", params[0]);
      }
      // setTrackerId(params[0]);

      // console.log("Tracker ID here 2: " + params[0]);

      partnerName = params[1];
      // console.log(partnerName)

      localStorage.setItem("PARTNER_NAME", params[1]);
      if (localStorage.getItem("PARTNER_NAME") == "tiktok" && otpSent == 0) {
        otpSent = 1;
        console.log("About to call TiktokPixel.track() while landing on Page");
        TiktokPixel.track("PageView", {
          content_type: "games",
          content_id: "User",
          currency: "PKR",
          value: 10,
        });
        window.fbq("track", "ButtonClicked");
      }
      console.log("PARTNER_NAME" + localStorage.getItem("PARTNER_NAME"));
    } catch (error) {
      // setTrackerId("noetic");
      // partnerName = "noetic";
      // setVInfo("undefined");

      if (
        params[0] == "null" ||
        params[0] == "undefined" ||
        params[0] == null
      ) {
        let mobikok = params[1];
        if (mobikok == "mobikok") {
          //
          setTrackerId(mobikok);
          console.log("Tracker ID here mobikok: " + mobikok);
        }

        if (mobikok == "propellerads") {
          setTrackerId(mobikok);
          console.log("Tracker ID here propellerads: " + mobikok);
        }

        if (mobikok == "2m18i") {
          setTrackerId(mobikok);
          console.log("Tracker ID here 2m18i: " + mobikok);
        }
        if (mobikok == "goldengoose") {
          setTrackerId(mobikok);
          console.log("Tracker ID here goldengoose: " + mobikok);
        }
        if (mobikok == "Innomovil") {
          setTrackerId(mobikok);
          console.log("Tracker ID here Innomovil: " + mobikok);
        }

        localStorage.setItem("TRACKER_ID", params[0]);
      } else {
        setTrackerId(params[0]);
        console.log("if (params[0] != null " + params[0]);
        localStorage.setItem("TRACKER_ID", params[0]);
      }
    }
    console.log("Getting tracker ID ++++++++" + getTrackerId());

    if (
      getTrackerId() == "" ||
      getTrackerId() == undefined ||
      getTrackerId() == null ||
      getTrackerId() == "undefined" ||
      getTrackerId() == "null"

      //
      // getTrackerId() == "" ||
      // getTrackerId() == undefined ||
      // getTrackerId() == null ||
      // getTrackerId() == "undefined" ||
      // getTrackerId() == "null"
    ) {
      if (
        getTrackerId() == "" ||
        getTrackerId() == undefined ||
        getTrackerId() == null ||
        getTrackerId() == "undefined" ||
        getTrackerId() == "null"
      ) {
        setTrackerId(localStorage.getItem("TRACKER_ID"));
      }
      {
      }
      // setTrackerId("noetic");
    }

    console.log("Tracker ID here 3: " + getTrackerId());
    let partner = TRACKERIDS.find((object) => object.partner === partnerName);
    console.log("Partner Name  is", partner);
    if (
      queryParams.get("msisdn") != undefined &&
      queryParams.get("msisdn") != "" &&
      queryParams.get("msisdn") != "not_found" &&
      queryParams.get("msisdn") != null &&
      queryParams.get("msisdn") != "null" &&
      partnerName != "noetic" &&
      partner !== undefined &&
      partner.partner != undefined &&
      partnerName != "2m7i"
    ) {
      localStorage.setItem("HeCase", true);
    }

    if (
      queryParams.get("msisdn") != undefined &&
      queryParams.get("msisdn") != "undefined" &&
      queryParams.get("msisdn") != "" &&
      queryParams.get("msisdn") != "not_found" &&
      queryParams.get("msisdn") != null &&
      queryParams.get("msisdn") != "null"
    ) {
      msisdnFetched = true;

      //msisdn format is from wuerypram is like 92304
      Msisdn = atob(queryParams.get("msisdn"));
      Msisdn = Msisdn / 99;
      console.log("Decrypted MSISDN: here by asad 2 " + Msisdn);
      Msisdn = String(Msisdn);
      Msisdn = Msisdn.slice(2, 12);
      Msisdn = "0" + Msisdn;
    }
    console.log("Partner ----->>>> " + partner);
    if (partner === undefined || partner === "") {
      partner = {
        clientId: "noetic_479",
        clientSc: "6KGZYO7YH2",
      };
    }

    if (
      partnerName === "2m9i" ||
      partnerName === "2m5i" ||
      partnerName === "2m13i" ||
      partnerName === "2m18i" ||
      partnerName === "2m6i" ||
      partnerName === "2m15i" ||
      partnerName === "2m12i" ||
      partnerName === "tiktok" ||
      partnerName === "mobplus" ||
      partnerName === "Innomovil" ||
      partnerName === "goldengoose"
    ) {
      GetMsisdn(queryParams.get("vInfo")).then(
        (res) => {
          if (res["code"] == "120") {
            localStorage.setItem("HeCase", true);
            Msisdn = res["msisdn"];
            msisdnFetched = true;
            Msisdn = String(Msisdn);
            Msisdn = Msisdn.slice(2, 12);
            Msisdn = "0" + Msisdn;
            document.getElementById("LoginMsisdn").value = Msisdn;
            console.log("This is the MSISDN", Msisdn);
            document.getElementById("LoginButton").click();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
    // else
    // {
    //   GetMsisdn(queryParams.get('vInfo')).then((res)=>{
    // 	  if(res['code'] == '120'){
    //     localStorage.setItem('HeCase', true);
    // 		Msisdn = res['msisdn'];
    // 		msisdnFetched = true;
    // 		Msisdn = String(Msisdn);
    // 		Msisdn = Msisdn.slice(2,12);
    // 		Msisdn = "0"+Msisdn;
    //     document.getElementById('LoginMsisdn').value=Msisdn
    // 		setTimeout(() => {
    // 		  document.getElementById('LoginButton').click();
    // 		}, 3000);
    // 	}
    // 	},(err)=>{
    // 	  console.log(err)
    // 	})
    // }

    if (!queryParams.has("vinfo") || [...queryParams.entries()].length <= 1) {
      window.location.href =
        "http://210.56.27.19:8080/get_jazz_header?vinfo=" +
        queryParams.get("vinfo");
    }

    clientLogin(btoa(partner["clientId"] + ":" + partner["clientSc"]))
      .then((response) => {
        localStorage.setItem("access_token", response.access_token);
      })
      .catch(error);
    {
    }

    // data.clientCredentials(btoa(partner['clientId'] + ':' + partner['clientSc'])).then((clientCredentialsResponse) => {
    //   alert(clientCredentialsResponse.data.access_token);
    // 	localStorage.setItem('access_token',clientCredentialsResponse.data.access_token);
    // },
    // (clientCredentialsError)=> {
    // 	console.log("Client Credentials Error" + clientCredentialsError);
    // });
    if (localStorage.getItem("HeCase") == true) {
      document.getElementById("LoginButton").click();
    }
  }, [location.search]);

  //Check the MSISDN type here prepaid / postpaid check

  const isMsisdnPrePaid = async (msisdn) => {
    if (msisdn === "923000748899") {
      return true;
    }
    try {
      const response = await axios.get(
        "https://jazz-prepaid-msisdn-check.ntgarage.com/dbss/prepaidPostpaidCheck/" +
          msisdn
      );

      if (response.data === "false" || response.data === false) {
        toast.error("Please enter a PrePaid Jazz number");
        //clear the input field

        navigate("/");

        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("Error checking MSISDN:", error);
      return false; // Return false in case of error
    }
  };

  async function onPlayClick(msisdn) {
    setIsLoading(true);
    const GameMsisdn = localStorage.getItem("no-msisdn");
    const isprepaid = await isMsisdnPrePaid("92" + msisdn.substring(1));
    // alert("reached")
    setisClicked(true);
    let regex_phone = /^(0)(3)([0-9]{9})$/;

    if (regex_phone.exec(msisdn) == null) {
    }

    if (regex_phone.exec(msisdn) != null && isprepaid === true) {
      //4. Calling Login API

      //Call the api to  check the User isCharged or not if charged naviate to home and wellcome
      // async function checkJazzSubscription(
      //   MSISDN = "92" + msisdn.substring(1)
      // ) {
      //   const TOCKEN = "Bearer" + " " + localStorage.getItem("access_token");

      //   const url = `https://dcb.noeticworld.com/sgw/user/otp-verification/is-jazz-msisdn-subscribed/${MSISDN}`;

      //   try {
      //     const response = await fetch(url, {
      //       method: "GET",
      //       headers: {
      //         Authorization: TOCKEN,
      //       },
      //     });

      //     const data = await response.json();

      //     if (data === true) {
      //       //if the res is true then navigate to the home without asking the OTP
      //       localStorage.setItem("jwt_j", "gT23bsdvsSACS128");
      //       localStorage.setItem("Welcome", MSISDN);
      //       // navigate("/Home");
      //     }
      //   } catch (error) {
      //     console.error("Error checking subscription:", error);
      //   }
      // }

      // // Call the function
      // checkJazzSubscription();

      msisdn = msisdn.substring(1);
      setMsisdn(msisdn);
      let body =
        "msisdn=" +
        "92" +
        msisdn +
        "&trackerId=" +
        getTrackerId() +
        "&otp=false";

      localStorage.setItem("no-msisdn", "92" + msisdn);
      //

      login(body).then(
        (loginResponse) => {
          // Break the req if not res from the api

          var requestStatu = setInterval(() => {
            requestStatus(loginResponse["correlationId"]).then(
              (requestStatusResponse) => {
                count++;

                // 118 - Valid User
                if (requestStatusResponse["code"] == "118") {
                  clearInterval(requestStatu);
                  if (
                    localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                    alreadyregister == 0
                  ) {
                    alreadyregister = 1;

                    TiktokPixel.track("Phone number submission", {
                      content_type: "games",
                      content_id: "92" + msisdn,
                      currency: "PKR",
                      value: 10,
                    });
                    window.fbq("track", "ButtonClicked");
                  }

                  if (localStorage.getItem("HeCase") == true) {
                    // this.data.Register(Md5.hashStr('92' + Number(this.Msisdn))).subscribe(
                    //   (registerResponse) => {
                    //     this.userToken = registerResponse['user_token'];
                    //     window.location.href =
                    //   this.data.skillpod_loginURL + this.userToken;
                    //   },
                    //   (registerError) => {
                    //     console.log(registerError);
                    //   }
                    // );
                    //change the OTP field to write

                    //change the OTP field to write
                    setIsLoading(false);
                    setisHideOTP(true);

                    // navigate(otpRoute);
                  } else {
                    //
                    setIsLoading(false);
                    //change the OTP field to write
                    setisHideOTP(true);
                    //navigate(otpRoute);
                  }
                  setIsLoading(false);
                  setSendOtp(true);
                }

                // 110 - Valid User
                if (requestStatusResponse["code"] == "110") {
                  setIsLoading(false);
                  clearInterval(requestStatu);
                  if (
                    localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                    alreadyregister == 0
                  ) {
                    alreadyregister = 1;

                    TiktokPixel.track("Phone number submission", {
                      content_type: "games",
                      content_id: "92" + msisdn,
                      currency: "PKR",
                      value: 10,
                    });
                    window.fbq("track", "ButtonClicked");
                  }

                  //change the OTP field to write
                  setIsLoading(false);
                  setisHideOTP(true);
                  //navigate(otpRoute);
                }

                // 119 - Invalid User ( Blocked User )
                if (requestStatusResponse["code"] == "119") {
                  setIsLoading(false);
                  clearInterval(requestStatu);
                  alert(`You have been Blocked from using this service`);
                  navigate("");
                }

                // 105 - Request in Progress
                if (requestStatusResponse["code"] == "105") {
                  setIsLoading(false);
                  if (count == 120) {
                    clearInterval(requestStatu);
                    navigate("");
                  }
                }

                // 305 - OTP Required
                if (requestStatusResponse["code"] == "305") {
                  setIsLoading(false);
                  if (
                    localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                    alreadyregister == 0
                  ) {
                    alreadyregister = 1;

                    TiktokPixel.track("Phone number submission", {
                      content_type: "games",
                      content_id: "92" + msisdn,
                      currency: "PKR",
                      value: 10,
                    });
                    window.fbq("track", "ButtonClicked");
                  }
                  clearInterval(requestStatu);
                  //change the OTP field to write
                  setIsLoading(false);
                  setSendOtp(true);
                  setisHideOTP(true);
                  //navigate(otpRoute);
                  //   navigate.navigate(otpRoute);
                }

                // 122 - Insufficient Balance
                if (requestStatusResponse["code"] == "122") {
                  clearInterval(requestStatu);
                  //change the OTP field to write

                  setIsLoading(false);
                  // navigate(otpRoute);
                }
              },
              (requestStatusError) => {
                console.log(requestStatusError);
                setIsLoading(false);
              }
            );
          }, 1000);
        },
        (loginError) => {
          //If the access token is expired or Invalid
          //   this.error = loginError.error.message;
        }
      );
    } else {
      setIsLoading(false);
      navigate("/");
    }
  }

  //Useefect from OTP page
  useEffect(() => {
    if (!SendOtp) return;

    TiktokPixel.init("CNE39KBC77UCVTJIS4D0");
    const fetchData = async () => {
      const accessToken = localStorage.getItem("access_token");
      const storedMsisdn = localStorage.getItem("no-msisdn");
      try {
        const response = await axios.get(
          `https://dcb.noeticworld.com/sgw/user/otp-verification/is-msisdn-charged-today/${storedMsisdn}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        checkcharged = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // setIsLoading(false);
      }
      // let body2 = {
      //   msisdn: localStorage.getItem("no-msisdn"),
      // };

      if (checkcharged == "1") {
        // await Register(body2).then((data) => {
        //   localStorage.setItem("jwt_j", data["token"]);
        //   Login(localStorage.getItem("jwt_j")).then(
        //     (Response) => {
        //       window.location.href = Response["url"];
        //       const msisdn_payload = {
        //         msisdn: localStorage.getItem("no-msisdn"),
        //       };
        //     },
        //     (err) => {}
        //   );
        // });
        localStorage.setItem("jwt_j", "gT23bsdvsSACS128-alc1");
        window.location.href = "/home";
      }
    };

    fetchData();

    //

    // const session = {
    //   userSessionId: localStorage.getItem("UserSessionId"),
    //   sessionType: "OTPPage",
    // };
    // userSession(session).then(
    //   (userSessionResponse) => {},
    //   (userSessionError) => {
    //     console.log(userSessionError);
    //   }
    // );

    const no_msisdn = localStorage.getItem("no-msisdn");
    let body =
      "msisdn=" +
      no_msisdn +
      "&trackerId=" +
      localStorage.getItem("TRACKER_ID") +
      "&otp=true";
    if (isClicked) {
      otpVerification(body).then(
        (otpVerificationResponse) => {
          if (
            localStorage.getItem("PARTNER_NAME") == "tiktok" &&
            otpSent === 0
          ) {
            otpSent = 1;

            TiktokPixel.track("OTP sent successful", {
              content_type: "games",
              content_id: getMsisdn(),
              currency: "PKR",
              value: 10,
            });
            window.fbq("track", "ButtonClicked");
          }

          setTimeout(() => {
            const Track = localStorage.getItem("msisdn");

            const tsring = Track ? Track.toString() : "";

            // Check if the value is found in localStorage
            if (
              tsring === "not_found" ||
              document.getElementById("LoginMsisdn").value == ""
            ) {
              // alert("Value found in localStorage");
              setIsLoading(false);
              // Break the operation after the alert
              return;
            }
            setIsLoading(false);
            // Continue the operation if the value is not "HE"
            fetchOtp(no_msisdn)
              .then((fetchOtpResponse) => {
                let otpValue =
                  typeof fetchOtpResponse === "number"
                    ? fetchOtpResponse.toString()
                    : fetchOtpResponse;

                if (otpValue.length === 4 && /^\d+$/.test(otpValue)) {
                  // Set the OTP in the state
                  setIsLoading(false);
                  setotp(fetchOtpResponse);
                } else {
                  setIsLoading(false);
                  // console.error("Fetched OTP is not 4 digits:", fetchOtpResponse);
                }
              })
              .catch((error) => {
                setIsLoading(true);
                console.error("Error fetching OTP:", error);
              });
          }, 1000);
        },
        (otpVerificationError) => {
          setIsLoading(false);
          console.error(otpVerificationError);
        },
        1000
      );
    }

    setStartTimer(true);
  }, [SendOtp]);

  //
  //Submit OTP Hadler
  const onCLickSubscribe = (otp) => {
    //

    //
    setIsLoading(true);
    if (otp == "") {
      toast.info("Please enter the valid 4 Digit OTP");
      setIsLoading(false);
      return 0;
    }

    if (!isChecked) {
      toast.error("Please agree to our Terms and Conditions before continuing");
      setIsLoading(false);
      return;
    }

    if (localStorage.getItem("no-msisdn") == "923000748899" && otp === "1234") {
      localStorage.setItem("jwt_j", "gT23bsdvsSACS128tst-n");

      window.location.href = "/home";
    }

    // otp = (atob(otp))/99;
    const no_msisdn = localStorage.getItem("no-msisdn");

    setMsisdn(no_msisdn);

    ///
    const regex_otp_validation = /[0-9][0-9][0-9][0-9]/;
    if (regex_otp_validation.exec(otp) == null) {
      alert("Please Enter your OTP");
      setIsLoading(false);
      return;
    }
    if (regex_otp_validation.exec(otp) != null) {
      var tracker = localStorage.getItem("TRACKER_ID");
      if (localStorage.getItem("TRACKER_ID") == "null") {
        tracker = "noetic tracker";
      }
      let body =
        "msisdn=" +
        getMsisdn() +
        "&trackerId=" +
        tracker +
        "&otp=true" +
        "&otpNumber=" +
        otp;

      login(body).then(
        async (loginResponse) => {
          const maxAttempts = 120;
          try {
            // await sleep(12000);
            for (let i = 0; i < maxAttempts; i++) {
              const requestStatusResponse = await requestStatus(
                loginResponse["correlationId"]
              );
              //
              const shouldBreak = await switchfunction(requestStatusResponse);
              if (shouldBreak) break; // 🔁 Exit early if flagged

              //
              await sleep(1000);
              await switchfunction(requestStatusResponse);
              count++;
            }
          } catch (error) {
            console.log(error);
          }

          function sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
          }

          async function switchfunction(requestStatusResponse) {
            switch (requestStatusResponse["code"]) {
              // 105 - Request in Progress
              case "105": {
                if (count == 120) {
                  // clearInterval(requestStatu);

                  window.location.reload();
                }

                break;
              }

              // 110 - Valid User ( Already Subscribed )
              case "110": {
                // let body2 = {
                //   msisdn: localStorage.getItem("no-msisdn"),
                // };
                localStorage.setItem("jwt_j", "gT23bsdvsSACS128alc110");
                window.location.href = "/home";
                // Register(body2).then((data) => {
                //   localStorage.setItem("jwt_j", data["token"]);

                //   Login(localStorage.getItem("jwt_j")).then(
                //     (Response) => {
                //       window.location.href = "/home";
                //     },
                //     (err) => {}
                //   );
                // });
                // clearInterval(requestStatu);

                localStorage.setItem("no-msisdn", getMsisdn());
                break;
              }

              // 120 - Invalid/Incorrect OTP
              case "120": {
                toast.error(
                  `Invalid User !\nThe OTP you have entered is incorrect`
                );

                if (SendOtp) {
                  setSendOtp(false);
                  setIsLoading(false);
                } else {
                  setSendOtp(true);
                  setIsLoading(false);
                }
                setotp("");

                return true; // ✅ Stop loop if incorrect OTP
              }

              // 118 - Valid User ( Already Subscribed ) Valid User
              case "118": {
                localStorage.setItem("jwt_j", "gT23bsdvsSACS128alc118");
                window.location.href = "/home";
                // let body2 = {
                //   msisdn: localStorage.getItem("no-msisdn"),
                // };

                // Register(body2).then((data) => {
                //   localStorage.setItem("jwt_j", data["token"]);

                //   // Login(data["token"]).then(
                //   //   (Response) => {
                //   //     console.log(Response["url"]);
                //   //     const msisdn_payload = {
                //   //       msisdn: localStorage.getItem("no-msisdn"),
                //   //     };
                //   //   },
                //   //   (err) => {
                //   //     console.error("Error in the api ", err);
                //   //   }
                //   // );
                //   setIsLoading(false);
                //   navigate("/home");
                // });
                //clearInterval(requestStatu);
                // alert("go to the home page");

                localStorage.setItem("no-msisdn", getMsisdn());
                return true; // ✅ Stop loop if incorrect OTP
              }

              // 119 - Invalid User ( Blocked User )

              case "119": {
                toast.error(
                  `You have been Blocked from using this service\nPlease contact Jazz Support Centre`
                );
                setIsLoading(false);
                navigate("");
                break;
              }

              // 116 - Postpaid User
              case "116": {
                toast.error(
                  "Unauthorized User !\nThis service is only for Jazz Prepaid users"
                );
                setIsLoading(false);
                // window.location.reload();
                navigate("/");
                break;
              }

              // 122 - Insufficient Balance
              case "122": {
                if (
                  localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                  alreadyregister == 0
                ) {
                  alreadyregister = 1;

                  TiktokPixel.track("Subscribe", {
                    content_type: "games",
                    content_id: getMsisdn(),
                    currency: "PKR",
                    value: 10,
                  });

                  window.fbq("track", "ButtonClicked");
                }
                toast.success(
                  "Successfully Subscribed !\nYou will be charged Rs.10.0/day after 1 day free trial."
                );
                localStorage.setItem("jwt_j", "gT23bsdvsSACS128sub122");
                window.location.href = "/home";
                // let body2 = {
                //   msisdn: getMsisdn(),
                // };
                // await Register(body2).then((registerResponse) => {
                //   localStorage.setItem("jwt_j", registerResponse["token"]);

                //   toast.success(
                //     "Successfully Subscribed !\nYou will be charged Rs.10.0/day after 1 day free trial."
                //   );

                //   Login(localStorage.getItem("jwt_j")).then(
                //     (res) => {
                //       window.location.href = res["url"];
                //       const msisdn_payload = {
                //         msisdn: localStorage.getItem("no-msisdn"),
                //       };
                //     },
                //     (err) => {}
                //   );
                // });
                // clearInterval(requestStatu);

                localStorage.setItem("no-msisdn", getMsisdn());
                setIsLoading(false);
                break;
              }

              //101 - Subscribed Successfully , Balance Deducted
              case "101": {
                ++countOfSuccess;
                if (countOfSuccess !== 1) return;
                if (
                  localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                  alreadyregister == 0
                ) {
                  alreadyregister = 1;

                  TiktokPixel.track("Subscribe", {
                    content_type: "games",
                    content_id: getMsisdn(),
                    currency: "PKR",
                    value: 10,
                  });

                  window.fbq("track", "ButtonClicked");
                }
                let body2 = {
                  msisdn: localStorage.getItem("no-msisdn"),
                };
                localStorage.setItem(
                  "jwt_j",
                  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
                );
                toast.success(`Successfully Subscribed !`);
                window.location.href = "/home";

                // await Register(body2).then((data) => {
                //   toast.success(`Successfully Subscribed !`);
                //   localStorage.setItem("jwt_j", data["token"]);

                //   navigate("/Home");

                //   Login(localStorage.getItem("jwt_j")).then(
                //     (res) => {
                //       const user = {
                //         msisdn: localStorage.getItem("no-msisdn"),
                //         avatarId: 1,
                //       };
                //       window.location.href = res["url"];
                //     },
                //     (err) => {}
                //   );
                // });
                // clearInterval(requestStatu);
                setIsLoading(false);
                //   this.conversion()
                localStorage.setItem("no-msisdn", getMsisdn());

                break;
              }

              //115 - Unauthorized - Not a Jazz User
              case "115": {
                // clearInterval(requestStatu);
                //   this.isLoaderHidden = true;

                toast.error(
                  "Unauthorized User !\nThis service is only for Jazz Prepaid users"
                );

                // window.location.reload();
                navigate("/login");
                break;
              }
            }
          }

          // Call handleRequestStatus initially
        },
        (loginError) => {
          console.error(loginError);
        }
      );
    }
  };
  //

  return (
    <div className={styles.LoginpageContainer}>
      <button className={styles.backButton} onClick={() => navigate(-1)}>
        <img
          src="https://cdn-icons-png.flaticon.com/128/271/271220.png"
          alt=""
        />
      </button>
      <section className={styles.InnerBox}>
        <div className={styles.LogoBox}>
          <img src="assets/images/logo (1).png" className={styles.Logo} />
        </div>

        <div className={styles.Welcome}>
          <h2 className="title" style={{ margin: "20px 0px" }}>
            Welcome to
            <br />
            GAMENOW
          </h2>
        </div>

        <div className={styles.ForMContainer}>
          <label htmlFor="Number">Enter your Jazz Number</label>
          <input
            type="tel"
            id="LoginMsisdn"
            placeholder="0300XXXXXXX"
            required
            className={styles.INPUT}
            readOnly={isHideOTP}
          />

          <div className={styles.ForMContainerOTP}>
            {isHideOTP ? (
              <label htmlFor="Code">Enter OTP</label>
            ) : (
              <label htmlFor="Code"></label>
            )}

            <OTPInput
              inputType="number"
              value={otp}
              onChange={setotp}
              id="OTP"
              numInputs={4}
              renderSeparator={<span>-</span>}
              renderInput={(props) => (
                <input
                  {...props}
                  readOnly={!isHideOTP}
                  type="tel"
                  style={{
                    width: "48px",
                    height: "48px",
                    textAlign: "center",
                    border: "none",
                    outline: "none",
                    borderRadius: "5px",
                    margin: "2px",
                    padding: "5px",
                  }}
                />
              )}
            />
            {isHideOTP && (
              <span className={styles.OTP_TIME}>
                {" "}
                Resend Code After: {Math.floor(timer / 60)}:
                {timer % 60 < 10 ? "0" : ""}
                {timer % 60}
              </span>
            )}

            {isHideOTP && (
              <button
                id="OTPButton"
                type="submit"
                className={styles.LoginButton}
                onClick={() => onCLickSubscribe(otp)}
                disbaled={IsLoading}
              >
                {IsLoading ? (
                  <>
                    <ActivityIndicator />
                  </>
                ) : (
                  "SUBSCRIBE"
                )}
              </button>
            )}
          </div>

          {!isHideOTP && (
            <button
              id="LoginButton"
              type="submit"
              disabled={IsLoading}
              onClick={() =>
                onPlayClick(document.getElementById("LoginMsisdn").value)
              }
              className={styles.LoginButton}
            >
              {IsLoading ? (
                <>
                  <ActivityIndicator />
                </>
              ) : (
                "Continue"
              )}
            </button>
          )}
        </div>

        <div className={styles.LoginTermsANdConditions}>
          <strong className={styles.TANC_TEXT}>
            Only For Jazz Prepaid Customers
          </strong>

          <strong className={styles.TANC_TEXT}>
            You will be charged up to Rs. 10/day, including tax.
          </strong>

          <span className={styles.CheckBox}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
            <label htmlFor="terms">I agree to the Terms and Conditions</label>
          </span>

          <Link to="/policy" className={styles.PrivacyPolicy}>
            Privacy Policy
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Login;
